module.exports = __webpack_public_path__ + "static/media/active_video_thumb4.b8c29365.svg";